import React, { useState, useEffect } from "react";
import { Typography, Button, useTheme, useMediaQuery } from "@mui/material";
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import "../assets/style/Styles.css";

import Overview from "./screens/Overview";
import AccountSettings from "./screens/AccountSettings";
import Payments from "./screens/Payments";
import Wallets from "./screens/Wallets";
import Transactions from "./screens/Transactions";
import SupportTickets from "./screens/SupportTickets";
import Exchange from "./screens/Exchange";
import StakePage from "./screens/StakePage";
import SafetyGuide from "./screens/SafetyGuide";

const drawerWidth = 280; // Ширина сайдбара

export default function DashboardLayout() {
  const [activeScreen, setActiveScreen] = useState("Overview");
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLanguage();

  // Адаптивные настройки
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  // isMobile будет true, если ширина экрана меньше 900px (breakpoint 'md')
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Синхронизируем состояние с URL
  useEffect(() => {
    const path = location.pathname;
    if (path === "/dashboard" || path === "/dashboard/overview") {
      setActiveScreen("Overview");
    } else if (path === "/dashboard/account-settings") {
      setActiveScreen("Account Settings");
    } else if (path === "/dashboard/payments") {
      setActiveScreen("Payments");
    } else if (path === "/dashboard/wallets") {
      setActiveScreen("Wallets");
    } else if (path === "/dashboard/transactions") {
      setActiveScreen("Transactions");
    } else if (path === "/dashboard/support-tickets") {
      setActiveScreen("Support Tickets");
    } else if (path === "/dashboard/safety-guide") {
      setActiveScreen("Safety Guide");
    } else if (path === "/dashboard/exchange") {
      setActiveScreen("Exchange");
    } else if (path === "/dashboard/stake") {
      setActiveScreen("Stake");
    }
  }, [location.pathname]);

  // Функция для навигации
  const handleScreenChange = (screen) => {
    setActiveScreen(screen);
    switch (screen) {
      case "Overview":
        navigate("/dashboard/overview");
        break;
      case "Account Settings":
        navigate("/dashboard/account-settings");
        break;
      case "Payments":
        navigate("/dashboard/payments");
        break;
      case "Wallets":
        navigate("/dashboard/wallets");
        break;
      case "Transactions":
        navigate("/dashboard/transactions");
        break;
      case "Support Tickets":
        navigate("/dashboard/support-tickets");
        break;
      case "Safety Guide":
        navigate("/dashboard/safety-guide");
        break;
      case "Exchange":
        navigate("/dashboard/exchange");
        break;
      case "Stake":
        navigate("/dashboard/stake");
        break;
      default:
        navigate("/dashboard/overview");
    }
  };

  const handleBuyCrypto = () => {
    navigate("/dashboard/payments");
  };

  const renderScreen = () => {
    switch (activeScreen) {
      case "Overview":
        return <Overview setActiveScreen={handleScreenChange} />;
      case "Account Settings":
        return <AccountSettings />;
      case "Payments":
        return <Payments />;
      case "Wallets":
        return <Wallets />;
      case "Transactions":
        return <Transactions />;
      case "Support Tickets":
        return <SupportTickets />;
      case "Safety Guide":
        return <SafetyGuide />;
      case "Exchange":
        return <Exchange />;
      case "Stake":
        return <StakePage />;
      default:
        return <Overview setActiveScreen={handleScreenChange} />;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        bgcolor: "#0f1924",
        color: "white",
        minHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Левый сайдбар */}
      <Sidebar
        drawerWidth={drawerWidth}
        activeScreen={activeScreen}
        setActiveScreen={handleScreenChange}
        isMobile={isMobile}
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
      />

      <Box
        component="main"
        sx={{ 
          flexGrow: 1, 
          width: `calc(100% - ${drawerWidth}px)`,
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
        }}
        className="main-container"
      >
        <TopBar activeScreen={activeScreen} isMobile={isMobile} handleDrawerToggle={handleDrawerToggle} />
        
        <Box
          sx={{
            flex: 1,
            overflow: "auto",
            p: 0,
          }}
        >
          <div className="content-container">
            <Box
              sx={{
                display: activeScreen === "Safety Guide" ? "none" : "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
              }}
            >
              {activeScreen !== "Support Tickets" && (
                <Typography variant="h4" fontWeight="bold">
                  {t(activeScreen === "Account Settings" ? "accountSettings" : activeScreen === "Safety Guide" ? "safetyGuide" : activeScreen.toLowerCase().replace(' ', ''))}
                </Typography>
              )}
              {activeScreen === "Overview" && (
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ textTransform: "none" }}
                  onClick={handleBuyCrypto}
                >
                  {t('buyCrypto')}
                </Button>
              )}
            </Box>

            {renderScreen(activeScreen)}
          </div>
        </Box>
      </Box>
    </Box>
  );
}
